export const ChangeRoute = (name) => {    
    return {
        type: 'change_route',
        payload: name
    }
}


